import React, { ReactNode } from 'react';
import {
  Label,
  Hidden,
  Mask,
  ErrorMessage
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';

interface Props {
  children?: ReactNode;
  checked?: boolean;
  colorActive?: string;
  name?: string;
  value?: string;
  handleChange?: Function;
  handleChangeInput?: Function;
  error?: boolean;
  disabled?: boolean;
  className?: string;
}

export const Checkbox: React.FC<Props> = ({
  children,
  checked,
  colorActive,
  name,
  value,
  handleChange,
  handleChangeInput,
  error,
  disabled,
  className
}) => {
  const onChangeProps = (e) => {
    handleChange && handleChange(e.currentTarget.checked);
    handleChangeInput && handleChangeInput(e);
  };

  return(
    <React.Fragment>
      <Label
        className={className}
        checked={checked}
        disabled={disabled}
        colorActive={colorActive}>
        <Hidden
          type="checkbox"
          name={name}
          value={value}
          onChange={onChangeProps}
          defaultChecked={checked }
        />
        <Mask>
          <Icon data-name="icon-check-short" fill="#fff" width="10" height="10" />
        </Mask>
        {children}
      </Label>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </React.Fragment>
)};

Checkbox.defaultProps = {
  colorActive: COLORS.GREEN
}
